import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Star, Award, Lock, CreditCard, Zap } from 'lucide-react';
const badges = [{
  icon: Award,
  text: 'BBB A+ Accredited'
}, {
  icon: Star,
  text: 'Google 5★ Rated (500+)'
}, {
  icon: ShieldCheck,
  text: 'Licensed #319535'
}, {
  icon: Lock,
  text: 'Bonded & Insured'
}, {
  icon: CreditCard,
  text: '0% Financing Available'
}, {
  icon: Zap,
  text: 'Same-Day Service'
}];
export function TrustBadges() {
  return <section className="bg-white border-b border-gray-100 py-6 overflow-hidden" data-id="element-334">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-335">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-wrap justify-center md:justify-between items-center gap-6 md:gap-4" data-id="element-336">
          {badges.map((badge, index) => <div key={index} className="flex items-center gap-2 text-gray-700 group" data-id="element-337">
              <badge.icon className="w-5 h-5 text-brand-red group-hover:scale-110 transition-transform" data-id="element-338" />
              <span className="text-sm font-bold uppercase tracking-wide" data-id="element-339">
                {badge.text}
              </span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}